import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { components } from "@/shared/api";

type StatAxis = components["schemas"]["StatAxis"];

// Слабая сторона игры как ошибка — значение плитки «Повторяющаяся ошибка».
export const WEAK_SPOT_LABELS: Record<StatAxis, MessageDescriptor> = {
  farm: msg`Low farm`,
  aggression: msg`Few kills`,
  teamwork: msg`Few assists`,
  survival: msg`Many deaths`,
};
